import { render, staticRenderFns } from "./Work_WorkUnits.vue?vue&type=template&id=122df7c4"
import script from "./Work_WorkUnits.vue?vue&type=script&lang=js"
export * from "./Work_WorkUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports